import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { AVAILABILITY_LOCALIZED_STATUS } from 'app/constants/AvailabilityConstants';

const branchShape = ImmutablePropTypes.contains({
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

// TODO: fill-out availability properties as required
// TODO: I don't know if availability.statusType is the same as AVAILABILITY_LOCALIZED_STATUS,
// but the values seem to overlap. We may need to update this when we understand what all the
// different status values are.
const bibItemShape = ImmutablePropTypes.contains({
  availability: ImmutablePropTypes.contains({
    statusType: PropTypes.oneOf(Object.values(AVAILABILITY_LOCALIZED_STATUS))
  }).isRequired,
  branch: branchShape.isRequired,
  branchName: PropTypes.string.isRequired,
  callNumber: PropTypes.string.isRequired,
  collection: PropTypes.string.isRequired,
  copy: PropTypes.string,
  inSiteScope: PropTypes.bool.isRequired,
  itemId: PropTypes.string.isRequired,
  preferred: PropTypes.bool,
  requestFormUrl: PropTypes.string,
  volume: PropTypes.string
});

export default bibItemShape;
